/**
 * @module views\dynamic\tablePage
 */
import Component from "vue-class-component";
import GhBase from "@/components/ghBase";

@Component({})
export default class TablePage extends GhBase {
  private args = { keyword: "" };
  private cls = "";

  protected onNavigateTo(paras) {
    if (paras && paras.args) {
      let args = eval("(" + paras.args + ")");
      let sourceId = args.sourceId;
      if (sourceId) {
        this.cls = sourceId;
      
      }
    }
  }
}
